import { ChangeEvent, useState, useEffect } from 'react';
import {
  Divider,
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableContainer,
  CardHeader,
  CardContent,
  Container,
  Grid,
  TextField,
} from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { debounce } from 'lodash';
import { TableLoader, TableNotFound } from 'src/Utils/TableLoader';
import { TOtherIncomeHeadList } from './type/otherIncomeType';
import GetDataApi from 'src/common/FetchData/GetDataApi';
import OtherIncomeHeadTableRow from './OtherIncomeHeadTableRow';

const OtherIncomeHeadList = () => {
  const [limit, setLimit] = useState<number>(25);
  const [_searchInvoiceVal, _setSearchInvoiceVal] = useState<string>('');
  const [filterItem, setFilterItem] = useState({
    name: '',
  });
  const [searchParams, setSearchParams] = useSearchParams({
    page: '0',
  });

  const page = parseInt(searchParams.get('page'));
  let uri = `/api/atab/income-head?CompanyProfileId=1&limit=${limit}&skip=${limit * page}`;
  if (filterItem.name) {
    uri += `&name=${filterItem?.name}`;
  }

  const { getData, loading, response, total } =
    GetDataApi<TOtherIncomeHeadList[]>(uri);
  useEffect(() => {
    (async function () {
      await getData();
    })();
  }, [page, limit, filterItem.name]);

  const handlePageChange = (_event: any, newPage: number): void => {
    searchParams.set('page', newPage.toString());
    setSearchParams(searchParams);
  };

  const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setLimit(parseInt(event.target.value));
  };
  const handelInputChange = debounce((value: string, key: string) => {
    setFilterItem((prevState: any) => ({
      ...prevState,
      [key]: value,
    }));
  }, 2000);
  return (
    <Container maxWidth='xl'>
      <Grid
        container
        direction='row'
        justifyContent='center'
        alignItems='stretch'
        spacing={3}
      >
        <Grid item xs={12}>
          <Card>
            <CardHeader
              action={
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: 1,
                  }}
                >
                  <TextField
                    label='Search by name'
                    id='standard-search'
                    type='search'
                    size='small'
                    variant='outlined'
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      handelInputChange(e.target.value, 'name')
                    }
                  />
                </Box>
              }
              title='Income Head List'
            />
            <Divider />

            <CardContent>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>SL</TableCell>
                      <TableCell>Income Head Name</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading ? (
                      <TableLoader />
                    ) : response?.length ? (
                      <>
                        {response?.map((item, index) => (
                          <OtherIncomeHeadTableRow
                            key={item.id}
                            incomeHeadData={item}
                            index={index}
                          />
                        ))}
                      </>
                    ) : (
                      <TableNotFound />
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <Box p={2}>
                <TablePagination
                  component='div'
                  count={total}
                  onPageChange={handlePageChange}
                  onRowsPerPageChange={handleLimitChange}
                  page={page && page}
                  rowsPerPage={limit}
                  rowsPerPageOptions={[25, 50, 75, 100]}
                />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default OtherIncomeHeadList;
